import Create from './create';
import Preview from './preview';

export default {
  Create,
  Preview,
};
